var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "portlet light bordered" }, [
    _c(
      "form",
      {
        staticClass: "form-horizontal",
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.getServings()
          }
        }
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "radio-label" }, [_vm._v("Zmiana z")]),
            _vm._v(" "),
            _c("label", { staticClass: "radio-inline" }, [
              _c("input", {
                attrs: {
                  type: "radio",
                  name: "change-from-option",
                  checked: ""
                },
                on: {
                  change: function($event) {
                    return _vm.setCheckedFrom("portion")
                  }
                }
              }),
              _vm._v("Składnika\n                ")
            ]),
            _vm._v(" "),
            _c("label", { staticClass: "radio-inline" }, [
              _c("input", {
                attrs: { type: "radio", name: "change-from-option" },
                on: {
                  change: function($event) {
                    return _vm.setCheckedFrom("component")
                  }
                }
              }),
              _vm._v("Posiłku składowego\n                ")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "radio-label" }, [_vm._v("Zmiana na")]),
            _vm._v(" "),
            _c("label", { staticClass: "radio-inline" }, [
              _c("input", {
                attrs: { type: "radio", name: "change-to-option", checked: "" },
                on: {
                  change: function($event) {
                    return _vm.setCheckedTo("portion")
                  }
                }
              }),
              _vm._v("Składnik\n                ")
            ]),
            _vm._v(" "),
            _c("label", { staticClass: "radio-inline" }, [
              _c("input", {
                attrs: { type: "radio", name: "change-to-option" },
                on: {
                  change: function($event) {
                    return _vm.setCheckedTo("component")
                  }
                }
              }),
              _vm._v("Posiłek składowy\n                ")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.checkedFrom === "portion",
                  expression: "checkedFrom === 'portion'"
                }
              ],
              staticClass: "col-md-6"
            },
            [
              _c("singleselect", {
                attrs: {
                  name: "from-portion",
                  options: _vm.portions,
                  "display-label": false,
                  label: "idAndName",
                  checked: _vm.fromPortion
                },
                model: {
                  value: _vm.fromPortion,
                  callback: function($$v) {
                    _vm.fromPortion = $$v
                  },
                  expression: "fromPortion"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.checkedFrom === "component",
                  expression: "checkedFrom === 'component'"
                }
              ],
              staticClass: "col-md-6"
            },
            [
              _c("singleselect", {
                attrs: {
                  name: "from-component",
                  options: _vm.components,
                  "display-label": false,
                  label: "idAndName",
                  checked: _vm.fromComponent
                },
                model: {
                  value: _vm.fromComponent,
                  callback: function($$v) {
                    _vm.fromComponent = $$v
                  },
                  expression: "fromComponent"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.checkedTo === "portion",
                  expression: "checkedTo === 'portion'"
                }
              ],
              staticClass: "col-md-6"
            },
            [
              _c("singleselect", {
                attrs: {
                  name: "to-portion",
                  options: _vm.portions,
                  "display-label": false,
                  label: "idAndName",
                  checked: _vm.toPortion
                },
                model: {
                  value: _vm.toPortion,
                  callback: function($$v) {
                    _vm.toPortion = $$v
                  },
                  expression: "toPortion"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.checkedTo === "component",
                  expression: "checkedTo === 'component'"
                }
              ],
              staticClass: "col-md-6"
            },
            [
              _c("singleselect", {
                attrs: {
                  name: "to-component",
                  options: _vm.components,
                  "display-label": false,
                  label: "idAndName",
                  checked: _vm.toComponent
                },
                model: {
                  value: _vm.toComponent,
                  callback: function($$v) {
                    _vm.toComponent = $$v
                  },
                  expression: "toComponent"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  (_vm.fromPortion || _vm.fromComponent) &&
                  (_vm.toPortion || _vm.toComponent),
                expression:
                  "(fromPortion || fromComponent) && (toPortion || toComponent)"
              }
            ],
            staticClass: "row"
          },
          [_c("div", { staticClass: "col-md-6" }), _vm._v(" "), _vm._m(0)]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.loading !== 0,
                expression: "loading !== 0"
              }
            ],
            staticClass: "row"
          },
          [
            _c(
              "div",
              { staticClass: "col-sm-12" },
              [
                _c("h2", [
                  _vm._v(_vm._s(_vm.trans("form.please_wait")) + "...")
                ]),
                _vm._v(" "),
                _c("ring-loader")
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showTable,
                expression: "showTable"
              }
            ],
            staticClass: "row"
          },
          [
            _c(
              "div",
              {
                staticClass: "col-md-12",
                staticStyle: { "padding-left": "23px" }
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.isCheckAll,
                      expression: "isCheckAll"
                    }
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: false,
                    checked: Array.isArray(_vm.isCheckAll)
                      ? _vm._i(_vm.isCheckAll, null) > -1
                      : _vm.isCheckAll
                  },
                  on: {
                    change: [
                      function($event) {
                        var $$a = _vm.isCheckAll,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.isCheckAll = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.isCheckAll = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.isCheckAll = $$c
                        }
                      },
                      _vm.checkAll
                    ]
                  }
                }),
                _vm._v(" "),
                _c("b", { staticStyle: { "padding-left": "8px" } }, [
                  _vm._v("Zaznacz wszystko")
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-12" }, [
              _c(
                "table",
                { staticClass: "table" },
                [
                  _c("thead", [
                    _c("tr", [
                      _c("th", [_vm._v("ID porcji")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Nazwa porcji")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("ID posiłku")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Nazwa posiłku")]),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: {
                                // eslint-disable-next-line vue/max-len
                                content:
                                  "Liczba Posiłków, które blokują możliwość podmiany składnika/posiłku składowego.<br/>Są to Posiłki zaplanowane w menu na najbliższe 7 dni.",
                                trigger: "hover",
                                placement: "top"
                              },
                              expression:
                                "{\n                                // eslint-disable-next-line vue/max-len\n                                content:'Liczba Posiłków, które blokują możliwość podmiany składnika/posiłku składowego.<br/>Są to Posiłki zaplanowane w menu na najbliższe 7 dni.',\n                                trigger: 'hover',\n                                placement: 'top',\n                                }"
                            }
                          ]
                        },
                        [_vm._v("PK w menu "), _c("sup", [_vm._v("?")])]
                      ),
                      _vm._v(" "),
                      _c("th")
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.servings, function(serving, index) {
                    return _c(
                      "tbody",
                      { key: index },
                      [
                        _c("tr", [
                          _c(
                            "td",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: {
                                    content:
                                      serving.finalMeals.length > 0
                                        ? "Posiłek występuje w menu na najbliższe 7 dni."
                                        : null,
                                    trigger: "hover",
                                    placement: "top"
                                  },
                                  expression:
                                    "{\n                                  content: serving.finalMeals.length > 0 ? 'Posiłek występuje w menu na najbliższe 7 dni.' : null,\n                                  trigger: 'hover',\n                                  placement: 'top',\n                                }"
                                }
                              ]
                            },
                            [
                              _c("input", {
                                ref: serving.id,
                                refInFor: true,
                                attrs: {
                                  type: "checkbox",
                                  disabled: serving.finalMeals.length > 0
                                },
                                domProps: { checked: false }
                              }),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  attrs: { href: "/serving/show/" + serving.id }
                                },
                                [_vm._v(_vm._s(serving.id))]
                              ),
                              _vm._v("  \n                            ")
                            ]
                          ),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(serving.name))]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "a",
                              {
                                attrs: { href: "/meal/show/" + serving.meal.id }
                              },
                              [_vm._v(_vm._s(serving.meal.id))]
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(serving.meal.name))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(serving.finalMeals.length))]),
                          _vm._v(" "),
                          serving.finalMeals.length > 0
                            ? _c("td", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.checkedServings[serving.id],
                                      expression: "checkedServings[serving.id]"
                                    }
                                  ],
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    checked: false,
                                    checked: Array.isArray(
                                      _vm.checkedServings[serving.id]
                                    )
                                      ? _vm._i(
                                          _vm.checkedServings[serving.id],
                                          null
                                        ) > -1
                                      : _vm.checkedServings[serving.id]
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.checkedServings[serving.id],
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.checkedServings,
                                              serving.id,
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.checkedServings,
                                              serving.id,
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.checkedServings,
                                          serving.id,
                                          $$c
                                        )
                                      }
                                    }
                                  }
                                }),
                                _c(
                                  "span",
                                  { staticStyle: { "padding-left": "8px" } },
                                  [_vm._v("Rozwiń listę PK")]
                                )
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _vm._l(serving.finalMeals, function(finalMeal) {
                          return _c(
                            "tr",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.checkedServings[serving.id],
                                  expression: "checkedServings[serving.id]"
                                }
                              ],
                              key: finalMeal.id
                            },
                            [
                              _c("td"),
                              _vm._v(" "),
                              _c("td", { attrs: { colspan: "5" } }, [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(finalMeal.id) +
                                      " " +
                                      _vm._s(finalMeal.name)
                                  )
                                ])
                              ])
                            ]
                          )
                        })
                      ],
                      2
                    )
                  })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-12" }, [
              _c("div", { staticClass: "col-md-6" }),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c(
                  "div",
                  {
                    staticClass: "col-md-10",
                    staticStyle: { "text-align": "right !important" }
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-light",
                        attrs: { type: "reset" },
                        on: {
                          click: function($event) {
                            return _vm.clearServings()
                          }
                        }
                      },
                      [_vm._v("Anuluj")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.unitMultiplier && _vm.ratioMultiplier,
                            expression: "unitMultiplier && ratioMultiplier"
                          }
                        ],
                        staticClass: "btn btn-success",
                        attrs: { type: "button" },
                        on: { click: _vm.swap }
                      },
                      [_vm._v("Podmień")]
                    )
                  ]
                )
              ])
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c(
        "div",
        {
          staticClass: "col-md-10",
          staticStyle: { "text-align": "right !important" }
        },
        [
          _c("button", { staticClass: "btn btn-success" }, [
            _vm._v("Znajdź porcje")
          ])
        ]
      )
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26a8163c", { render: render, staticRenderFns: staticRenderFns })
  }
}